import React from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    className,
    ImageComponent,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';

export default function FeaturePointsSection({
    title,
    titleTag,
    textNode,
    id,
    imagePosition,
    imagePositionMobile,
    buttons,
    image,
    colorScheme,
    backgroundColorScheme,
    points,
}) {

    colorScheme = colorScheme?.toLowerCase();
    backgroundColorScheme = backgroundColorScheme?.toLowerCase();
    const imageDesktopIsRight = imagePosition === 'Right';
    const imageMobileIsBottom = imagePositionMobile === 'Bottom';
    const hasBackgroundColorScheme = backgroundColorScheme !== 'none';

    return (
        <section
            aria-labelledby={id}
            {...className(
                [
                    'mt-10 mb-10 mb-lg-20',
                    style.section,
                    hasBackgroundColorScheme ? sectionStyle['with-bg'] : '',
                    hasBackgroundColorScheme
                        ? sectionStyle['with-bg--alt2']
                        : '',
                    hasBackgroundColorScheme
                        ? colorStyle[`with-bg--${backgroundColorScheme}`]
                        : '',
                ].join(' ')
            )}
        >
            {hasBackgroundColorScheme ? (
                <div
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    {...className(`${sectionStyle.bg} ${colorStyle.bg}`)}
                />
            ) : null}
            <Container pt={{ xs: 10, lg: 15 }}>
                <Row
                    className={
                        hasBackgroundColorScheme
                            ? `text-lg-center`
                            : 'text-center'
                    }
                    pb={{
                        xs: 5,
                        lg: hasBackgroundColorScheme ? 5 : 15,
                    }}
                >
                    <Col
                        col={{ lg: hasBackgroundColorScheme ? 8 : 10 }}
                        offset={{ lg: hasBackgroundColorScheme ? 2 : 1 }}
                    >
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`h2 mb-5 ${textStyle.gradual} ${style.heading}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                    {textNode.contentWithoutWrapperUnderline ? (
                        <Col col={{ lg: 8 }} offset={{ lg: 2 }}>
                            <Text
                                tag="p"
                                className={`h3 mb-5 ${textStyle['child-underline']
                                    } ${textStyle[`child-underline--${colorScheme}`]
                                    } ${style.pointText}`}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {textNode.contentWithoutWrapperUnderline}
                            </Text>
                        </Col>
                    ) : null}
                </Row>
                <Row
                    className={
                        hasBackgroundColorScheme ? '' : 'align-items-lg-center'
                    }
                >
                    <Col
                        col={{
                            lg: hasBackgroundColorScheme ? 5 : 4,
                        }}
                        offset={{ lg: 1 }}
                        order={{
                            xs: imageMobileIsBottom ? 1 : 2,
                            lg: imageDesktopIsRight ? 1 : 2,
                        }}
                        pb={{
                            xs: imageMobileIsBottom ? 5 : 0,
                            lg: 13,
                        }}
                    >
                        {points.map((point, i) => (
                            <div
                                key={i}
                                {...className(
                                    `${textStyle['child-underline']} ${textStyle[
                                    `child-underline--${colorScheme}`
                                    ]
                                    } pb-${hasBackgroundColorScheme ? 2 : 5}`
                                )}
                                data-sal={`slide-up--lg-${imageDesktopIsRight ? 'right' : 'left'
                                    }`}
                                data-sal-easing="ease-out-quart"
                            >
                                {point.title ? (
                                    <Heading
                                        tag="h5"
                                        className={`mb-3 ${style.pointTitle}`}
                                    >
                                        {point.title}
                                    </Heading>
                                ) : null}
                                {point.textNode &&
                                    point.textNode
                                        .contentWithoutWrapperUnderline ? (
                                    <Text
                                        tag="div"
                                        className={`${hasBackgroundColorScheme
                                            ? 'h4'
                                            : 'body'
                                            } ${textStyle['child-underline']} ${textStyle[
                                            `child-underline--${colorScheme}`
                                            ]
                                            } ${textStyle['with-list']} ${style.pointSubText
                                            }`}
                                    >
                                        {
                                            point.textNode
                                                .contentWithoutWrapperUnderline
                                        }
                                    </Text>
                                ) : null}
                            </div>
                        ))}
                        {buttons && buttons.length ? (
                            <div
                                {...className('mt-5')}
                                data-sal={`slide-up--lg-${imageDesktopIsRight ? 'right' : 'left'
                                    }`}
                                data-sal-easing="ease-out-quart"
                            >
                                <ButtonComponent
                                    focusWhite={backgroundColorScheme == 'primary' ? true : false}
                                    blockMobile={true}
                                    buttons={buttons}
                                />
                            </div>
                        ) : null}
                    </Col>
                    <Col
                        col={{
                            lg: hasBackgroundColorScheme ? 4 : 5,
                        }}
                        offset={{
                            lg: 1,
                        }}
                        order={{
                            xs: imageMobileIsBottom ? 2 : 1,
                            lg: imageDesktopIsRight ? 2 : 1,
                        }}
                        pb={{
                            xs: imageMobileIsBottom ? 0 : 10,
                        }}
                    >
                        <div
                            className={
                                hasBackgroundColorScheme
                                    ? `${style['image-wrapper']} ${style[
                                    `image-wrapper--${imageDesktopIsRight
                                        ? 'right'
                                        : 'left'
                                    }`
                                    ]
                                    }`
                                    : ''
                            }
                            data-sal={`slide-up--lg-${imageDesktopIsRight ? 'left' : 'right'
                                }`}
                        >
                            <ImageComponent
                                image={image}
                                className={style.image}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
